import { useState } from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { useNavigate } from "react-router-dom";

const DomainLookup = () => {
  const [value, setValue] = useState("");
  const navigate = useNavigate();

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = () => {
    navigate("/domain/search/" + value);
  };

  return (
    <Paper>
      <form onSubmit={handleSubmit} style={{ justifyContent: "center" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            id="outlined-name"
            label="Email"
            value={value}
            onChange={handleChange}
            margin="normal"
            variant="outlined"
            style={{ marginLeft: 5, marginRight: 5 }}
          />
          <Button
            variant="contained"
            type="submit"
            color="secondary"
            style={{ marginLeft: 5, marginRight: 5 }}
          >
            Submit
          </Button>
        </div>
      </form>
    </Paper>
  );
};

export default DomainLookup;
